import { ReactNode } from 'react';

import { ArrowLeft } from '../assets';
import { cn } from '../lib';
import { Button, ButtonProps } from './button';

type DashboardBackButtonProps = Omit<ButtonProps, 'variant' | 'size'> & {
  icon?: ReactNode;
};

export const DashboardBackButton = ({
  icon = <ArrowLeft className="min-h-6 min-w-6" />,
  className,
  ...props
}: DashboardBackButtonProps) => {
  return (
    <Button
      className={cn('min-h-12 min-w-12 rounded-full p-0', className)}
      variant="base-300"
      {...props}
    >
      {icon}
    </Button>
  );
};
